<div class="animate-fade-in-up-delay-2 rounded-lg border bg-white p-6 shadow-sm">
	<p class="leading-relaxed text-gray-600">
		or really anyone who's already on the road and driving through neighborhoods where vacant
		and distressed looking property is!
	</p>
	<p class="text-foreground mt-4 font-medium">
		Talk to people and ask: "Do you know anyone that has thought about selling their property?"
	</p>
</div>
